module.exports = __webpack_public_path__ + "img/ZArec4C_013_ZDRE01M0-front.55e1373a.jpg";